// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9y0-0","placeholdersHeader":"styles_placeholdersHeader__2-O7g","editorStyle":"styles_editorStyle__5iFrf","placeholdersBox":"styles_placeholdersBox__2p5dK"};